/**
 * @generated SignedSource<<0881e1672944b5ddf49dce7c0cf47e35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Terms_featuredDeal$data = {
  readonly artist: {
    readonly displayName: string;
    readonly managerCompany: string | null;
    readonly managerLink: string | null;
    readonly managerName: string | null;
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"AvatarIcon_actor" | "useMessage_actor">;
  };
  readonly id: string;
  readonly partnerSplitPostRecoupment: number | null;
  readonly partnerSplitPreRecoupment: number | null;
  readonly releases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly soundLink: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"ReleasesInfoRemovable_release">;
      } | null;
    } | null>;
  };
  readonly termLengthMonths: number | null;
  readonly unreleasedReleases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly soundLink: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"ReleasesInfoRemovable_release">;
      } | null;
    } | null>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReleasesInfoRemovable_offerFeaturedDeal">;
  readonly " $fragmentType": "Terms_featuredDeal";
};
export type Terms_featuredDeal$key = {
  readonly " $data"?: Terms_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"Terms_featuredDeal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "soundLink",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ReleasesInfoRemovable_release"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Terms_featuredDeal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ReleaseNodeConnection",
      "kind": "LinkedField",
      "name": "releases",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReleaseNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReleaseNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnreleasedReleaseNodeConnection",
      "kind": "LinkedField",
      "name": "unreleasedReleases",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnreleasedReleaseNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UnreleasedReleaseNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termLengthMonths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerSplitPreRecoupment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerSplitPostRecoupment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArtistNode",
      "kind": "LinkedField",
      "name": "artist",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useMessage_actor"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarIcon_actor"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managerCompany",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "managerLink",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReleasesInfoRemovable_offerFeaturedDeal"
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};
})();

(node as any).hash = "0192c288537f4ea93cdc336b9ba6f026";

export default node;
